import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Table from './components/Table';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import SessionManager from './components/SessionManager';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  return (
    <Router>
      <SessionManager token={token} setToken={setToken} />
      <Routes>
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route element={<PrivateRoute token={token} />}>
          <Route path="/" element={<Table />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
